import { appClient } from 'src/config/apollo';
import { ToastNotificationsService } from 'src/shared/services/ToastNotificationsService';
import { GetMyProvidersDocument } from '../documents/getMyProvidersQuery.generated';

export class ProvidersService {
    constructor(private toastNotificationsService: ToastNotificationsService) {
        this.toastNotificationsService = toastNotificationsService;
    }

    public fetchMyProviders(): Promise<void> {
        return appClient
            .query({
                query: GetMyProvidersDocument,
                fetchPolicy: 'network-only',
            })
            .then(() => {})
            .catch(() =>
                this.toastNotificationsService.renderErrorToast('Could not fetch providers.'),
            );
    }
}
